import { ReactComponent as PlusSvg } from '@/commons/icons/ope/plus.svg';
import { ReactComponent as CloseSvg } from '@/commons/icons/ope/close.svg';
import { ReactComponent as DeleteSvg } from '@/commons/icons/side-bar/side-delete.svg';
import { ReactComponent as SaveSvg } from '@/commons/icons/side-bar/side-save.svg';
import { ReactComponent as CancelSvg } from '@/commons/icons/side-bar/side-cancel.svg';
import { forwardRef, useContext, useEffect, useRef, useState } from 'react';
import './index.less';
import { Modal, Skeleton, message } from 'antd';
import { useParams } from 'react-router-dom';
import SectionLib from './section-lib';
import SectionAdd from './section-add';
import { checkSectionsHasBeenUsed, deleteProjectSectionMulti, getSectionsByprojectUuid, getSystemSectionParamIns } from '@/api/spec-common/section';
import { PSection, ParamIn } from '@/commons/interface/speccommon/section';
import SectionDetail from './section-detail';
import { getSectionTypeItemInfo } from '@/commons/enums/speccommon/section';
import SectionCustom from './section-custom';
import SectionModify from './section-modify';
import { SideStatus } from '@/commons/context/side-store';
import { HavcContext, SideContext, StructureContext } from '@/App';
import TnModal from '@/commons/widget/base-modal';
import { StructureStatus } from '@/commons/context/structure-store';
import { MAJOR, getMajorName } from "@/commons/constants/major";
import { HavcStatus } from "@/commons/context/havc-store";
import localStore from '@/commons/store/local-store';

const AddChild = forwardRef(SectionAdd);
const DetailChild = forwardRef(SectionDetail);
const ModityChild = forwardRef(SectionModify);
const CustomChild = forwardRef(SectionCustom);

interface Iprops {
    width: number
}
export default function SectionPanel(props: Iprops) {
    const sideContext = useContext<SideStatus>(SideContext);
    const ref = useRef(null);
    const { projectUuid } = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [detail, setDetail] = useState<PSection>(null); // 查看详情的截面
    const [paramIns, setParamIns] = useState<ParamIn[]>([]);
    const [mode, setMode] = useState<'lib' | 'add' | 'custom' | 'detail' | 'modify'>('lib');
    const [deleting, setDeleting] = useState<boolean>(false); // 处于删除状态中
    const [selectedSections, setSelectedSections] = useState<PSection[]>([]); // 删除的选中项

    const structureContext = useContext<StructureStatus>(StructureContext);
    const havcContext = useContext<HavcStatus>(HavcContext);

    const addRef = useRef(null)
    const detailRef = useRef(null)
    const customRef = useRef(null)
    const modifyRef = useRef(null)

    // 获取项目截面数据
    const generateData = () => {
        setLoading(true);
        getSectionsByprojectUuid(projectUuid, sideContext.selectedMajorUuid).then(res => {
            if (res.status === 200) {
                let data: PSection[] = res.data || [];
                if (sideContext.selectedMajorUuid === MAJOR.STRUCTURE) {
                    structureContext.setSections(data);
                } else if (sideContext.selectedMajorUuid === MAJOR.HVAC) {
                    havcContext.setSections(data);
                }
            }
        }).catch(err => {
            message.error("获取数据失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    // 获取系统截面参数
    const generateParamInData = () => {
        getSystemSectionParamIns().then(res => {
            if (res.status === 200) {
                let data: ParamIn[] = res.data || [];
                setParamIns(data);
            }
        }).catch(err => {
            message.error("获取数据失败");
        })
    }

    useEffect(() => {
        generateParamInData();
    }, [])

    useEffect(() => {
        if (mode === 'lib') {
            generateData();
        }
    }, [mode, sideContext.selectedMajorUuid])

    const closeClick = () => {
        if (mode === 'lib') {
            if (sideContext.lastPanel === 'component-assemble') {
                sideContext.setSelectedPanelValue('component-assemble');
            } else {
                sideContext.setSelectedPanelValue(null);
            }
            sideContext.setLastPanel(null);
        } else {
            setMode('lib');
        }
    }

    const viewSectionDetail = (id: string, mode: 'detail' | 'modify') => {
        if (mode === 'detail') {
            setMode('detail');
        } else {
            setMode('modify');
        }
        let secArr = sideContext.selectedMajorUuid === MAJOR.STRUCTURE ? structureContext.sections : havcContext.sections;
        let section: PSection = secArr?.find(item => item?.id === id);
        setDetail(section);
    }

    const deleteSections = () => {
        if (!selectedSections || selectedSections?.length === 0) {
            setDeleting(false);
            return;
        }

        TnModal().deleteModal({
            closable: false,
            onOk() {
                let ids: string[] = selectedSections?.map(item => item.id);
                checkSectionsHasBeenUsed(projectUuid, ids).then(res => {
                    if (res.status === 200) {
                        let usedIds: string[] = res.data || [];
                        let canRemoveIds = ids?.filter(item => !usedIds.includes(item));
                        if (canRemoveIds?.length > 0) {
                            deleteProjectSectionMulti(projectUuid, canRemoveIds).then((res) => {
                                if (res.status == 200) {
                                    if (sideContext.selectedMajorUuid === MAJOR.STRUCTURE) {
                                        const newList = structureContext.sections.filter((item) => !canRemoveIds.some(u => u === item.id));
                                        structureContext.setSections(newList);
                                    } else if (sideContext.selectedMajorUuid === MAJOR.HVAC) {
                                        const newList = havcContext.sections.filter((item) => !canRemoveIds.some(u => u === item.id));
                                        havcContext.setSections(newList);
                                    }
                                    let msgStr = `${canRemoveIds?.length}个截面删除成功`;
                                    if (usedIds?.length > 0) {
                                        msgStr = msgStr.concat(`；${usedIds?.length}个截面未删除，存在构件使用该截面`)
                                    }
                                    message.success(msgStr);
                                    // message.success("删除成功");
                                    setDeleting(false);
                                    setSelectedSections([]);
                                }
                            }).catch(() => {
                                message.error("删除失败");
                            }).finally(() => {
                                Modal.destroyAll();
                            })
                        } else {
                            message.error(`删除失败，所有截面均有构件使用`);
                            Modal.destroyAll();
                        }
                    }
                }).catch(() => {
                    Modal.destroyAll();
                })

            },
            onCancel() {
                Modal.destroyAll();
            }
        })
    }

    const onChildAddClick = () => {
        if (mode == 'add') {
            if (addRef.current) {
                if (addRef.current.isSelfDefine) {
                    addRef.current.handleInsertCustom();
                } else {
                    addRef.current.handleInsert();
                }
            }
        } else if (mode == 'detail') {
            if (detailRef.current) {
                detailRef.current.handleInsert()
            }
        } else if (mode == 'custom') {
            if (customRef.current) {
                setMode('lib')
            }
        } else if (mode == 'modify') {
            if (modifyRef.current) {
                modifyRef.current.handleInsert()
            }
        }
    }

    return (
        <Skeleton active loading={loading}>
            <div className='section-panel-container'>
                <div className='header' ref={ref}>
                    <div className='name-area'>
                        <div className='name'>截面{`${getMajorName(sideContext.selectedMajorUuid || localStore.getSelectedMajor())}`}</div>
                        {mode === 'add' && <div className='ellipsis'>{`>添加截面`}</div>}
                        {mode === 'detail' && <div className='ellipsis' style={{ maxWidth: props.width - 110 }}>{`>${getSectionTypeItemInfo(detail?.type)?.label} ${detail?.name}`}</div>}
                        {mode === 'custom' && <div className='ellipsis' style={{ maxWidth: props.width - 110 }}>{`>自定义截面`}</div>}
                        {mode === 'modify' && <div className='ellipsis' style={{ maxWidth: props.width - 110 }}>{`>${getSectionTypeItemInfo(detail?.type)?.label} ${detail?.name}`}</div>}
                    </div>
                    <div className='icon-group'>
                        {!deleting && mode === 'lib' && <>
                            <DeleteSvg onClick={() => setDeleting(true)} />
                            <PlusSvg onClick={(e) => {
                                setMode('add');
                            }} />
                            <CloseSvg onClick={closeClick} />
                        </>}
                        {deleting && <>
                            <SaveSvg onClick={deleteSections} />
                            <CancelSvg onClick={() => { setDeleting(false); setSelectedSections([]); }} />
                        </>}
                        {!deleting && mode != 'lib' && <>
                            <SaveSvg onClick={() => { onChildAddClick() }} />
                            <CancelSvg onClick={() => { setMode('lib') }} />
                        </>}
                    </div>
                </div>
                <div className='body'>
                    {mode === 'lib' && <SectionLib
                        sections={sideContext.selectedMajorUuid === MAJOR.STRUCTURE ? structureContext.sections : havcContext.sections}
                        setSections={sideContext.selectedMajorUuid === MAJOR.STRUCTURE ? structureContext.setSections : havcContext.setSections}
                        viewSectionDetail={viewSectionDetail}
                        width={props.width}
                        deleting={deleting}
                        selectedSections={selectedSections}
                        setSelectedSections={setSelectedSections}
                    />}
                    {mode === 'add' && <AddChild
                        ref={addRef}
                        sections={sideContext.selectedMajorUuid === MAJOR.STRUCTURE ? structureContext.sections : havcContext.sections}
                        paramIns={paramIns}
                        goBack={() => { setMode('lib') }}
                        width={props.width} />}
                    {mode === 'detail' && <DetailChild ref={detailRef} section={detail} goBack={() => { setMode('lib') }} width={props.width} />}
                    {mode === 'custom' && <CustomChild
                        ref={customRef}
                        sections={sideContext.selectedMajorUuid === MAJOR.STRUCTURE ? structureContext.sections : havcContext.sections}
                        paramIns={paramIns}
                        goBack={() => { setMode('lib') }}
                        width={props.width} />}
                    {mode === 'modify' && <ModityChild ref={modifyRef} section={detail} goBack={() => { setMode('lib') }} width={props.width} />}
                </div>
            </div>
        </Skeleton>

    )
}